export const convertToString = (value: string | number | null | undefined): string => value?.toString() || '';
